import React from 'react';

export const PatolaBorder = ({ className = '' }) => {
  return (
    <div
      className={`h-2 w-full lux-patola-band ${className}`}
      aria-hidden="true"
      data-testid="luxury-patola-border"
    />
  );
};
